import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { ProcessDataComponent } from './process-data.component';

export const ProcessData = connect((sState: AppState) => ({ sState }))(
  //@ts-ignore
  ProcessDataComponent as any
) as unknown as typeof ProcessDataComponent;
